import React, { memo } from 'react'
import {
  faCheckCircle,
  faExclamationCircle
} from '@fortawesome/pro-duotone-svg-icons'

import { Label } from '../label'

const AccountStatusLabel = ({ isConnected, t }) => {
  const { statusLabel, statusIcon, statusColor } = isConnected
    ? {
        statusLabel: 'common.connected',
        statusIcon: faCheckCircle,
        statusColor: 'success'
      }
    : {
        statusLabel: 'settings.not-connected',
        statusIcon: faExclamationCircle,
        statusColor: 'default'
      }

  return (
    <Label variant='soft' startIcon={statusIcon} color={statusColor}>
      {t(statusLabel)}
    </Label>
  )
}

export default memo(AccountStatusLabel)
